const TaxonModel = {
    findByPermalink: (permalink, taxons = [], prefix = '/t/') => taxons.find((taxon) => `${prefix}${taxon.permalink}` === permalink),

    image: (imageId, taxonList = {}) => taxonList.included.filter((item) => item.type === 'taxon_image' && imageId === item.id),
};

export default TaxonModel;



/** WEBPACK FOOTER **
 ** ./src/services/taxon-model.js
 **/